import React, { Component } from 'react';
import { connect } from 'react-redux';
import PriceChangesFiltersView from './PriceChangeFilters.view';

export class PriceChangesFiltersContainer extends Component {
  render() {
    return (<PriceChangesFiltersView
      {...this.props}
    />);
  }
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps)(PriceChangesFiltersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/PriceChanges/PriceChangeFilters/PriceChangeFilters.container.js